// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"1038d21f","247":"e19bd3a4","312":"6822f6ae","457":"862560ab","484":"c44a3a54","488":"979916ff","627":"a2d859be","640":"b52d4df2","653":"08bdf09e","828":"5811c888","842":"cddf5f38","867":"798fe952","923":"97e63dfd","938":"4cec5427","950":"68ccd83d"}[chunkId] + ".chunk.js";
};